import React from "react";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { useTranslations } from '../../../locales/useTranslations';
import { BiCalendar, BiKey, BiHdd, BiArchive, BiSupport, BiCode, BiData, BiBug, BiAnalyse, BiMobile, BiSearchAlt } from "react-icons/bi";

const WordpressWebsiteManagement = () => {
    const { t } = useTranslations();

    return (
        <>
            <section className="ptb-100 bg-f4f6fc">
                <div className="container">
                    <div className="section-title">
                        <h2 className="mb-2" style={{ color: "#59bd65" }}>{t('wordpressSupport_management_title')}</h2>
                    </div>
                    <p>
                        {t('wordpressSupport_management_description')}
                    </p>

                    {/* Erste Reihe - Grundlegende Services */}
                    <div className="row mb-4">
                        <div
                            className="col-lg-3 col-sm-6 feature-card"
                            data-aos="fade-up"
                            data-aos-delay="100"
                            data-aos-duration="1200"
                        >
                            <div className="single-features-card blt-radius-0" style={{
                                background: 'linear-gradient(135deg, #59bd65 0%, #4CAF50 100%)',
                                color: 'white',
                                border: 'none',
                                boxShadow: '0 8px 25px rgba(89, 189, 101, 0.3)'
                            }}>
                                <BiCalendar className="blt-radius-0" style={{ color: '#59bd65', fontSize: '2.5rem', padding: '10px', height: '64px', width: '64px', marginBottom: '10px', background: "white" }} />
                                <h3 style={{ color: 'white' }}>
                                    {t('wordpressSupport_management_features_item1_title')}
                                </h3>
                                <p style={{ color: 'rgba(255,255,255,0.9)' }}>
                                    {t('wordpressSupport_management_features_item1_description')}
                                </p>
                            </div>
                        </div>

                        <div
                            className="col-lg-3 col-sm-6 feature-card"
                            data-aos="fade-up"
                            data-aos-delay="200"
                            data-aos-duration="1200"
                        >
                            <div className="single-features-card blt-radius-0" style={{
                                background: 'linear-gradient(135deg, #59bd65 0%, #4CAF50 100%)',
                                color: 'white',
                                border: 'none',
                                boxShadow: '0 8px 25px rgba(89, 189, 101, 0.3)'
                            }}>
                                <BiKey className="blt-radius-0" style={{ color: '#59bd65', fontSize: '2.5rem', padding: '10px', height: '64px', width: '64px', marginBottom: '10px', background: "white" }} />
                                <h3 style={{ color: 'white' }}>
                                    {t('wordpressSupport_management_features_item2_title')}
                                </h3>
                                <p style={{ color: 'rgba(255,255,255,0.9)' }}>
                                    {t('wordpressSupport_management_features_item2_description')}
                                </p>
                            </div>
                        </div>

                        <div
                            className="col-lg-3 col-sm-6 feature-card"
                            data-aos="fade-up"
                            data-aos-delay="300"
                            data-aos-duration="1200"
                        >
                            <div className="single-features-card blt-radius-0" style={{
                                background: 'linear-gradient(135deg, #59bd65 0%, #4CAF50 100%)',
                                color: 'white',
                                border: 'none',
                                boxShadow: '0 8px 25px rgba(89, 189, 101, 0.3)'
                            }}>
                                <BiHdd className="blt-radius-0" style={{ color: '#59bd65', fontSize: '2.5rem', padding: '10px', height: '64px', width: '64px', marginBottom: '10px', background: "white" }} />
                                <h3 style={{ color: 'white' }}>
                                    {t('wordpressSupport_management_features_item3_title')}
                                </h3>
                                <p style={{ color: 'rgba(255,255,255,0.9)' }}>
                                    {t('wordpressSupport_management_features_item3_description')}
                                </p>
                            </div>
                        </div>

                        <div
                            className="col-lg-3 col-sm-6 feature-card"
                            data-aos="fade-up"
                            data-aos-delay="400"
                            data-aos-duration="1200"
                        >
                            <div className="single-features-card blt-radius-0" style={{
                                background: 'linear-gradient(135deg, #59bd65 0%, #4CAF50 100%)',
                                color: 'white',
                                border: 'none',
                                boxShadow: '0 8px 25px rgba(89, 189, 101, 0.3)'
                            }}>
                                <BiArchive className="blt-radius-0" style={{ color: '#59bd65', fontSize: '2.5rem', padding: '10px', height: '64px', width: '64px', marginBottom: '10px', background: "white" }} />
                                <h3 style={{ color: 'white' }}>
                                    {t('wordpressSupport_management_features_item4_title')}
                                </h3>
                                <p style={{ color: 'rgba(255,255,255,0.9)' }}>
                                    {t('wordpressSupport_management_features_item4_description')}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Zweite Reihe - Erweiterte Services */}
                    <div className="row">
                        <div
                            className="col-lg-3 col-sm-6 feature-card"
                            data-aos="fade-up"
                            data-aos-delay="500"
                            data-aos-duration="1200"
                        >
                            <div className="single-features-card blt-radius-0" style={{
                                background: 'linear-gradient(135deg, #080a3c 0%, #1a1c4a 100%)',
                                color: 'white',
                                border: 'none',
                                boxShadow: '0 8px 25px rgba(8, 10, 60, 0.3)'
                            }}>
                                <BiSupport className="blt-radius-0" style={{ color: '#59bd65', fontSize: '2.5rem', padding: '10px', height: '64px', width: '64px', marginBottom: '10px', background: "white" }} />
                                <h3 style={{ color: 'white' }}>
                                    {t('wordpressSupport_management_features_item11_title')}
                                </h3>
                                <p style={{ color: 'rgba(255,255,255,0.9)' }}>
                                    {t('wordpressSupport_management_features_item11_description')}
                                </p>
                            </div>
                        </div>

                        <div
                            className="col-lg-3 col-sm-6 feature-card"
                            data-aos="fade-up"
                            data-aos-delay="600"
                            data-aos-duration="1200"
                        >
                            <div className="single-features-card blt-radius-0" style={{
                                background: 'linear-gradient(135deg, #080a3c 0%, #1a1c4a 100%)',
                                color: 'white',
                                border: 'none',
                                boxShadow: '0 8px 25px rgba(8, 10, 60, 0.3)'
                            }}>
                                <BiCode className="blt-radius-0" style={{ color: '#59bd65', fontSize: '2.5rem', padding: '10px', height: '64px', width: '64px', marginBottom: '10px', background: "white" }} />
                                <h3 style={{ color: 'white' }}>
                                    {t('wordpressSupport_management_features_item10_title')}
                                </h3>
                                <p style={{ color: 'rgba(255,255,255,0.9)' }}>
                                    {t('wordpressSupport_management_features_item10_description')}
                                </p>
                            </div>
                        </div>

                        <div
                            className="col-lg-3 col-sm-6 feature-card"
                            data-aos="fade-up"
                            data-aos-delay="700"
                            data-aos-duration="1200"
                        >
                            <div className="single-features-card blt-radius-0" style={{
                                background: 'linear-gradient(135deg, #080a3c 0%, #1a1c4a 100%)',
                                color: 'white',
                                border: 'none',
                                boxShadow: '0 8px 25px rgba(8, 10, 60, 0.3)'
                            }}>
                                <BiData className="blt-radius-0" style={{ color: '#59bd65', fontSize: '2.5rem', padding: '10px', height: '64px', width: '64px', marginBottom: '10px', background: "white" }} />
                                <h3 style={{ color: 'white' }}>
                                    {t('wordpressSupport_management_features_item5_title')}
                                </h3>
                                <p style={{ color: 'rgba(255,255,255,0.9)' }}>
                                    {t('wordpressSupport_management_features_item5_description')}
                                </p>
                            </div>
                        </div>

                        <div
                            className="col-lg-3 col-sm-6 feature-card"
                            data-aos="fade-up"
                            data-aos-delay="800"
                            data-aos-duration="1200"
                        >
                            <div className="single-features-card blt-radius-0" style={{
                                background: 'linear-gradient(135deg, #080a3c 0%, #1a1c4a 100%)',
                                color: 'white',
                                border: 'none',
                                boxShadow: '0 8px 25px rgba(8, 10, 60, 0.3)'
                            }}>
                                <BiBug className="blt-radius-0" style={{ color: '#59bd65', fontSize: '2.5rem', padding: '10px', height: '64px', width: '64px', marginBottom: '10px', background: "white" }} />
                                <h3 style={{ color: 'white' }}>
                                    {t('wordpressSupport_management_features_item6_title')}
                                </h3>
                                <p style={{ color: 'rgba(255,255,255,0.9)' }}>
                                    {t('wordpressSupport_management_features_item6_description')}
                                </p>
                            </div>
                        </div>
                    </div>


                    {/* Dritte Reihe - Zusätzliche Services */}
                    <div className="row mt-4 mb-4">
                        <div
                            className="col-lg-4 col-sm-6 feature-card"
                            data-aos="fade-up"
                            data-aos-delay="900"
                            data-aos-duration="1200"
                        >
                            <div className="single-features-card blt-radius-0" style={{
                                background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
                                color: 'white',
                                border: 'none',
                                boxShadow: '0 8px 25px rgba(255, 107, 53, 0.3)',
                            }}>
                                <BiSearchAlt className="blt-radius-0" style={{ color: '#59bd65', fontSize: '2.5rem', padding: '10px', height: '64px', width: '64px', marginBottom: '10px', background: "white" }} />
                                <h3 style={{ color: 'white' }}>
                                    {t('wordpressSupport_management_features_item7_title')}
                                </h3>
                                <p style={{ color: 'rgba(255,255,255,0.9)' }}>
                                    {t('wordpressSupport_management_features_item7_description')}
                                </p>
                            </div>
                        </div>

                        <div
                            className="col-lg-4 col-sm-6 feature-card"
                            data-aos="fade-up"
                            data-aos-delay="1000"
                            data-aos-duration="1200"
                        >
                            <div className="single-features-card blt-radius-0" style={{
                                background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
                                color: 'white',
                                border: 'none',
                                boxShadow: '0 8px 25px rgba(255, 107, 53, 0.3)',
                            }}>
                                <BiMobile className="blt-radius-0" style={{ color: '#59bd65', fontSize: '2.5rem', padding: '10px', height: '64px', width: '64px', marginBottom: '10px', background: "white" }} />
                                <h3 style={{ color: 'white' }}>
                                    {t('wordpressSupport_management_features_item8_title')}
                                </h3>
                                <p style={{ color: 'rgba(255,255,255,0.9)' }}>
                                    {t('wordpressSupport_management_features_item8_description')}
                                </p>
                            </div>
                        </div>

                        <div
                            className="col-lg-4 col-sm-6 feature-card"
                            data-aos="fade-up"
                            data-aos-delay="1100"
                            data-aos-duration="1200"
                        >
                            <div className="single-features-card blt-radius-0" style={{
                                background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
                                color: 'white',
                                border: 'none',
                                boxShadow: '0 8px 25px rgba(255, 107, 53, 0.3)',
                            }}>
                                <BiAnalyse className="blt-radius-0" style={{ color: '#59bd65', fontSize: '2.5rem', padding: '10px', height: '64px', width: '64px', marginBottom: '10px', background: "white" }} />
                                <h3 style={{ color: 'white' }}>
                                    {t('wordpressSupport_management_features_item9_title')}
                                </h3>
                                <p style={{ color: 'rgba(255,255,255,0.9)' }}>
                                    {t('wordpressSupport_management_features_item9_description')}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Call-to-Action Bereich */}
                    <div className="row mt-5">
                        <div className="col-12 text-center">
                            <div style={{
                                background: 'linear-gradient(135deg, #59bd65 0%, #4CAF50 100%)',
                                padding: '3rem',
                                borderRadius: '15px',
                                color: 'white',
                                boxShadow: '0 15px 35px rgba(89, 189, 101, 0.3)'
                            }}>
                                <h3 style={{ color: 'white', marginBottom: '1rem' }}>
                                    {t('wordpressSupport_management_cta_title')}
                                </h3>
                                <p style={{ color: 'rgba(255,255,255,0.9)', fontSize: '1.1rem', marginBottom: '2rem' }}>
                                    {t('wordpressSupport_management_cta_description')}
                                </p>
                                <a
                                    href="/kontakt"
                                    className="default-btn"
                                    style={{
                                        background: 'white',
                                        color: '#59bd65',
                                        padding: '12px 30px',
                                        borderRadius: '25px',
                                        textDecoration: 'none',
                                        fontWeight: 'bold',
                                        transition: 'all 0.3s ease',
                                        display: 'inline-block'
                                    }}
                                    onMouseOver={(e) => {
                                        e.target.style.background = '#f8f9fa';
                                        e.target.style.transform = 'translateY(-2px)';
                                    }}
                                    onMouseOut={(e) => {
                                        e.target.style.background = 'white';
                                        e.target.style.transform = 'translateY(0)';
                                    }}
                                >
                                    {t('wordpressSupport_management_cta_button')}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
        </>
    );
};

export default WordpressWebsiteManagement;
